import React from 'react'
import ManageBooksDetail from '../manage-books/ManageBooksDetail';
import { ELibraryCategory } from '../../enum/elibrary_enum';
import { routeName } from '../../../../routes/routeName';

type Props = {
    view: boolean;
}

const ManageAudioBookDetail = ({ view }: Props) => {
    return (
        <ManageBooksDetail
            library_category_name={ELibraryCategory.AUDIO_BOOK}
            view={view}
            menu_name={'จัดการหนังสือเสียง'}
            menu_name_detail='เพิ่มหนังสือเสียง'
            menu_name_detail_edit='รายละเอียดหนังสือเสียง'
            menu_path_name={routeName.e_library.manage_audio_book}
        />
    )
}

export default ManageAudioBookDetail